'use client'

import { useMemo } from 'react'
import { useTranslations } from 'next-intl'
import { Button } from '@/components/ui/button'
import { unwrapMarkdownFence } from '@/lib/markdown/markdown-fence'

type MarkdownFenceNoticeProps = {
  markdown: string
  onApply: (markdown: string) => void
}

export function MarkdownFenceNotice({
  markdown,
  onApply,
}: MarkdownFenceNoticeProps) {
  const t = useTranslations('MarkdownEditorShared')
  const unwrapped = useMemo(() => unwrapMarkdownFence(markdown), [markdown])

  if (unwrapped === null) return null

  return (
    <div className="mb-3 flex flex-shrink-0 flex-col gap-3 rounded-lg border border-border bg-muted/50 p-3 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-sm text-muted-foreground" aria-live="polite">
        {t('fencedMarkdownHint')}
      </p>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="self-start sm:shrink-0 sm:self-auto"
        onClick={() => onApply(unwrapped)}
      >
        {t('unwrapMarkdown')}
      </Button>
    </div>
  )
}
